import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'

import { DefaultNewReportForm, schema } from './new-report-form-schema'

export const caneOptions = {
  gramineas_porte_alto: false,
  gramineas_porte_baixo: false,
  mamona: false,
  trepadeiras: false,
  daninhas_indefinidas: false,
  outras_folhas_largas: false,
}

export const soybeanOptions = {
  gramineas_porte_medio: false,
  gramineas_porte_baixo: false,
  buva: false,
  daninhas_indefinidas: false,
  outras_folhas_largas: false,
  capim_amargoso: false,
}

export function NewReportFormProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const methods = useForm<DefaultNewReportForm>({
    resolver: zodResolver(schema),

    defaultValues: {
      cane_options: caneOptions,
      soybean_options: soybeanOptions,
    },
  })
  return <FormProvider {...methods}>{children}</FormProvider>
}
export const useNewReportForm = () => {
  return useFormContext<DefaultNewReportForm>()
}
